import { createSlice } from "@reduxjs/toolkit";

//CONSTANTS
export const SELECTED_MODELS = "selectedModels";
export const SHEETS_SELECTED = "sheetsSelected";
export const SELECTED_SHEET = "selectedSheet";
export const SELECTED_DRAWING_SET = "selectedDrawingSet";
export const MODEL_LOADED = "modelLoaded";
export const SELECTED_TAG = "selectedTag";
export const SELECTED_GUID = "selectedGuid";
export const SHOW_ALL = "showAll";
export const SHOW_SELECTION = "showSelection";
export const PDF_DATA = "pdfData";
export const IS_PDF = "isPdf";
export const BOUNDING_BOX = "boundingBox";
export const GEO_LOCATION_EXT = "geoLocationExt";
export const GEO_LOCATION_ACTIVE = "geoToolActive";
export const LAUNCH_VIEWER = "launchViewer";
export const VIEWER_OPEN = "viewerOpen";
export const MODEL_DATA = "modelData"; // Maybe change to project Data?
export const MODEL_DATA_LOADED = "modelDataLoaded";
export const MODEL_CATEGORIES = "modelCategories";
export const MODEL_FILTER_STATE = "modelFilterState";
export const SELECTED_OBJECT_DATA = "selectedObjectData";
export const SELECTED_OBJECT_DATA_LOADING = "selectedObjectDataLoading";
export const DATA_CHANGES = "dataChanges";
export const MODEL_DATA_PROJECT_ID = "modelDataProjectId";
export const NUMBER_OF_LOADED_MODELS = "numberOfLoadedModels";

// export const PENDING_DYNAMIC_CHANGES = "pendingDynamicChanges";

//INITIAL STATE OBJECT
const initialState = {
  [SELECTED_MODELS]: [],
  [SHEETS_SELECTED]: false,
  [SELECTED_SHEET]: null,
  [SELECTED_SHEET]: null,
  [MODEL_LOADED]: false,
  [SELECTED_TAG]: "",
  [SELECTED_GUID]: "",
  [SHOW_ALL]: false,
  [SHOW_SELECTION]: false,
  [PDF_DATA]: {},
  [IS_PDF]: false,
  [BOUNDING_BOX]: {},
  [GEO_LOCATION_EXT]: null,
  [GEO_LOCATION_ACTIVE]: false,
  [LAUNCH_VIEWER]: false,
  [VIEWER_OPEN]: false,
  [MODEL_DATA]: null,
  [MODEL_DATA_LOADED]: false,
  [MODEL_CATEGORIES]: null,
  [MODEL_FILTER_STATE]: { process: null, status: null, discipline: null },
  [SELECTED_OBJECT_DATA]: null,
  [SELECTED_OBJECT_DATA_LOADING]: false,
  [DATA_CHANGES]: [],
  [MODEL_DATA_PROJECT_ID]: null,
  [NUMBER_OF_LOADED_MODELS]: 0,
};

// //REDUCER
// export const modelReducer = (state = initialState, action = {}) => {
//   if (action.type === "modelReducer") {
//     return {
//       ...state,
//       [action.stateName]: action.payload,
//     };
//   } else {
//     return state;
//   }
// };

// //ACTION
// export function updateModelState(payload) {
//   return {
//     type: "modelReducer",
//     payload: payload.value,
//     stateName: payload.stateName,
//   };
// }

export const modelSlice = createSlice({
  name: "modelReducer",
  initialState: initialState,
  reducers: {
    updateModelState: (state, action) => {
      // state[action.payload.stateName] = action.payload.value;
      return {
        ...state,
        [action.payload.stateName]: action.payload.value,
      };
    },
  },
});

export const { updateModelState } = modelSlice.actions;

export const modelReducer = modelSlice.reducer;
